import type { AvailableLanguage } from './i18n';

export const languageData: Record<AvailableLanguage, { flag: string; english: string; local: string }> = {
    en: { flag: '🇺🇸', english: 'English', local: 'English' },
    fr: { flag: '🇫🇷', english: 'French', local: 'Français' },
    de: { flag: '🇩🇪', english: 'German', local: 'Deutsch' },
    it: { flag: '🇮🇹', english: 'Italian', local: 'Italiano' },
    es: { flag: '🇪🇸', english: 'Spanish', local: 'Español' },
    ru: { flag: '🇷🇺', english: 'Russian', local: 'Русский' },
    id: { flag: '🇮🇩', english: 'Indonesian', local: 'Bahasa Indonesia' },
    ar: { flag: '🇸🇦', english: 'Arabic', local: 'العربية' },
    th: { flag: '🇹🇭', english: 'Thai', local: 'ไทย' },
    vi: { flag: '🇻🇳', english: 'Vietnamese', local: 'Tiếng Việt' },
    tr: { flag: '🇹🇷', english: 'Turkish', local: 'Türkçe' },
    nl: { flag: '🇳🇱', english: 'Dutch', local: 'Nederlands' },
    pl: { flag: '🇵🇱', english: 'Polish', local: 'Polski' },
    ko: { flag: '🇰🇷', english: 'Korean', local: '한국어' },
    hi: { flag: '🇮🇳', english: 'Hindi', local: 'हिन्दी' },
};

export function getLanguageDisplayName(langCode: string): string {
    const data = languageData[langCode as AvailableLanguage];
    if (!data) return langCode.toUpperCase();
    
    // Format: 🇷🇺 Russian (Русский)
    if (data.english === data.local) {
        return `${data.flag} ${data.english}`;
    }
    return `${data.flag} ${data.english} (${data.local})`;
}